import { SelectControl } from "../../create-request/models/OptionDropdownSelect";

export const payIncomeModel: SelectControl = {
    title: 'Pay income',
    controlName: 'payIncome',
    options: [
        {
            value: '',
            name: ''
        },
        {
            value: 'A',
            name: 'All'
        },
        {
            value: 'D',
            name: 'Dividend'
        },
        {
            value: 'I',
            name: 'Interest'
        },
        {
            value: 'M',
            name: 'Money Market'
        }
    ],
    showOptionalLabel: true,
    validationMessage: `Please select 'Frequency' from dropdown.`
};